function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M64 64v384h384V64H64zm368 368H79V80h353v352z"
});

var _ref2 = /*#__PURE__*/React.createElement("circle", {
  cx: 304,
  cy: 176,
  r: 16
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M96 96v256h320V96H96zm198.6 240H153.4L224 235.8 294.6 336zm-6.2-36.6l22.3-31.6 48 68.2h-44.6l-25.7-36.6zM400 336h-21.7l-67.6-96-32.1 45.5L224 208l-90.1 128H112V112h288v224z"
});

const SvgIosImageOutline = ({
  svgRef,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 512 512",
  ref: svgRef
}, props), _ref, _ref2, _ref3);

const ForwardRef = React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgIosImageOutline, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/ios-image-outline.612e5b95.svg";
export { ForwardRef as ReactComponent };